module.exports = __webpack_public_path__ + "img/2022_GPB.fbc11124.jpg";